import request from '@/utils/request'

export function eventFlow(data) {
  return request({
    url: 'api/v1/event/flow',
    method: 'post',
    data: data
  })
}

export function offlineAvgSpin(data) {
  return request({
    url: 'api/v1/event/offlineAvgSpin',
    method: 'post',
    data: data
  })
}

export function actCollectStage(data) {
  return request({
    url: 'api/v1/event/actStage',
    method: 'post',
    data: data,
    timeout: 50000
  })
}
